import cs from 'classnames';
import React from 'react';
import { Slug } from 'rental/app/steps';
import { PoweredByBanner } from 'shared/chrome/PoweredByBanner';
import { Banner } from 'shared/nav/Banner';
import { Menu } from 'shared/steps/steps';
import { App_ApplicationFragment, App_PortalFragment } from '../generated.graphql';


interface Props {
  portal: App_PortalFragment;
  application: App_ApplicationFragment | null
  menu: Menu<Slug> | null
}


export const PortalBanner = ({portal, application, menu}: Props) => (
  <Banner
    menu={menu}
    logoLink={portal.portalUrl || portal.addProductUrl}
    logoSrc={application?.inStore?.storeLogo || portal.portalLogoUrl || null}
    logoTitle={application?.inStore?.storeName || portal.title}
    processingTimeMessage={
      portal?.myApplication?.inStore ? (
        "Please Note: Applications generally take 1 hour to process.  We will contact you shortly if we need to discuss your application."
      ) : (
        "Please Note: Applications generally take 1-2 business days to process."
      )
    }
  >
    {application?.testMode.application && (
      <div className="text-white small p-1 text-center bg-warning">
        TEST MODE: App will NOT be processed on completion.<br/>
      </div>
    )}

    {application?.testMode.bankStatements && (
      <div className="text-white small p-1 text-center bg-info">
        BANK STATEMENTS TEST MODE: For using the test bank accounts.
      </div>
    )}

    {portal.isStudio19 && <PoweredByBanner value="Studio 19 Rentals" bodyClassName={cs('portal-studio19', `portal-${portal.slug}`)} />}
  </Banner>
);
